"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSearchFiltersTemplate = void 0;
const lit_html_1 = require("lit-html");
const decorators_js_1 = require("lit/decorators.js");
const lit_1 = require("lit");
const typedi_1 = require("typedi");
const jquery_1 = __importDefault(require("jquery"));
require("jquery-ui/ui/core");
require("jquery-ui/ui/widgets/slider");
window.jQuery = jquery_1.default;
require('jquery-ui-touch-punch');
const control_1 = require("@common/form/control");
const translation_1 = require("@translation/services/translation");
const category_1 = require("@category/services/category");
const filters_1 = require("@category/services/filters");
/**
 * Всплывающее окно резервирования домена
 */
let SearchFiltersPopup = class SearchFiltersPopup extends lit_1.LitElement {
    /**
     * Конструктор
     */
    constructor() {
        super();
        /**
         * Загрузка
         */
        this.loading = false;
        /**
         * Форма
         */
        this.form = new control_1.Form({
            word_param: new control_1.TextControl('contain'),
            word: new control_1.TextControl(''),
            price: new control_1.TextControl(''),
            price_to: new control_1.TextControl(''),
            letter: new control_1.TextControl(''),
            letter_to: new control_1.TextControl(''),
            reserved: new control_1.TextControl('1'),
        });
        /**
         * Get параметр для сортировки
         */
        this.sortValue = '';
        /**
         * Направление сортировки
         */
        this.orderValue = {
            name: 'name_asc',
            length: 'length_asc',
            price: 'price_asc',
        };
        this.categoryService = typedi_1.Container.get(category_1.CategoryService);
        this.categorySearchFilter = typedi_1.Container.get(filters_1.CategorySearchFilter);
        this.translationService = typedi_1.Container.get(translation_1.TranslationService);
        this.apply = this.apply.bind(this);
        this.form.patchValue(this.formatFilterValue(this.categorySearchFilter.toApi()));
        this.initSort();
    }
    /**
     * Устанавливает корень структуры
     */
    createRenderRoot() {
        return this;
    }
    /**
     * Создает элемент ползунка
     */
    createRangeSlider(inputMin, inputMax, maxValue = 10000, step = 10) {
        const initalPriceVal = this.form.getValue()[inputMin] || 0;
        const initalPriceToVal = this.form.getValue()[inputMax] || maxValue;
        const inputMinControl = this.form.get(inputMin);
        const inputMaxControl = this.form.get(inputMax);
        const sliderConfig = {
            range: true,
            orientation: "horizontal",
            min: 0,
            max: maxValue,
            values: [initalPriceVal, initalPriceToVal],
            step,
            slide: function (_, ui) {
                if (ui.values[0] == ui.values[1]) {
                    return false;
                }
                (0, jquery_1.default)("[name='" + inputMin + "']").val(ui.values[0]);
                inputMinControl === null || inputMinControl === void 0 ? void 0 : inputMinControl.setValue(ui.values[0]);
                (0, jquery_1.default)("[name='" + inputMax + "']").val(ui.values[1]);
                inputMaxControl === null || inputMaxControl === void 0 ? void 0 : inputMaxControl.setValue(ui.values[1]);
            }
        };
        return (0, jquery_1.default)('<div class="range-slider"></div>').slider(sliderConfig);
    }
    /**
     * Возвращает форму фильтра по словам
     */
    get wordFilter() {
        return (0, lit_html_1.html) `<div class="option-group">
                <div class="flex">
                    <div class="checkbox-area">
                        <input 
                            name="word_param"
                            value="contain"
                            @change="${this.change}"
                            ?checked="${this.form.getValue().word_param === 'contain'}"
                            type="radio"
                            class="radio" id="radio_contain" />
                        <label for="radio_contain">${this.translationService.instant('av_contain')}</label>
                    </div>
                    <div class="checkbox-area">
                        <input 
                            type="radio" name="word_param" value="begin"
                            @change="${this.change}"
                            ?checked="${this.form.getValue().word_param === 'begin'}"
                            class="radio" id="radio_begin" />
                        <label for="radio_begin">${this.translationService.instant('av_begin')}</label>
                    </div>
                    <div class="checkbox-area">
                    <input 
                        type="radio" name="word_param" value="end"
                        @change="${this.change}"
                        ?checked="${this.form.getValue().word_param === 'end'}"
                        class="radio" id="radio_end" />
                    <label for="radio_end">${this.translationService.instant('av_end')}</label>
                </div>
                </div>
                <div class="art-field__wrap">
                    <art-text-field class="art-field" placeholder="${this.translationService.instant('anyWord')}" name="word" .control="${this.form.get('word')}" @enter="${this.apply}"></art-text-field>
                </div>
        </div>`;
    }
    ;
    /**
     * Возвращает шаблон фильтров сортировки
     */
    get sortFilter() {
        return (0, lit_html_1.html) `<div class="checkbox-area ascdesc">
                            <input name="sort" 
                                @change="${this.changeSort}"
                                ?checked="${this.sortValue === ''}"
                                type="radio" value="" class="radio" id="radio_all" />
                            <label for="radio_all">${this.translationService.instant('all')}</label>
                        </div>
                        <div class="checkbox-area ascdesc">
                            <input name="sort" 
                                   type="radio" class="radio" value="${this.orderValue.name}" id="radio_name"
                                   @change="${this.changeSort}"
                                   ?checked="${this.sortValue === 'name_asc' || this.sortValue === 'name_desc'}" />
                            <label for="radio_name" @click="${this.clickSort}">${this.translationService.instant('av_by_name')}</label>
                            <button type="button" @click="${this.changeAsc}" data-name="name">
                                <svg width="5" height="7" viewBox="0 0 5 7" fill="none" xmlns="http://www.w3.org/2000/svg" class="${this.orderValue.name.replace('name_', '')}">
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M2.85056 0.5L2.84553 5.16005L3.74805 4.25754L4.24302 4.75251L2.49553 6.5L0.748047 4.75251L1.24302 4.25754L2.14553 5.16005L2.15056 0.5H2.85056Z" fill="#D50712"/>
                                </svg>
                            </button>
                        </div>
                        <div class="checkbox-area ascdesc">
                            <input name="sort" 
                                   type="radio" class="radio" value="${this.orderValue.length}" id="radio_length"
                                   @change="${this.changeSort}"
                                   ?checked="${this.sortValue === 'length_asc' || this.sortValue === 'length_desc'}" />
                            <label for="radio_length" @click="${this.clickSort}">${this.translationService.instant('av_by_length')}</label>
                            <button type="button" @click="${this.changeAsc}" data-name="length">
                                <svg width="5" height="7" viewBox="0 0 5 7" fill="none" xmlns="http://www.w3.org/2000/svg" class="asc">
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M2.85056 0.5L2.84553 5.16005L3.74805 4.25754L4.24302 4.75251L2.49553 6.5L0.748047 4.75251L1.24302 4.25754L2.14553 5.16005L2.15056 0.5H2.85056Z" fill="#D50712"/>
                                </svg>
                            </button>
                        </div>
                        <div class="checkbox-area ascdesc">
                            <input name="sort" 
                                   type="radio" class="radio" value="${this.orderValue.price}" id="radio_price"
                                   @change="${this.changeSort}"
                                   ?checked="${this.sortValue === 'price_asc' || this.sortValue === 'price_desc'}"/>
                            <label for="radio_price" @click="${this.clickSort}">${this.translationService.instant('av_by_price')}</label>
                            <button type="button" @click="${this.changeAsc}" data-name="price">
                                <svg width="5" height="7" viewBox="0 0 5 7" fill="none" xmlns="http://www.w3.org/2000/svg" class="asc">
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M2.85056 0.5L2.84553 5.16005L3.74805 4.25754L4.24302 4.75251L2.49553 6.5L0.748047 4.75251L1.24302 4.25754L2.14553 5.16005L2.15056 0.5H2.85056Z" fill="#D50712"/>
                                </svg>
                            </button>
                        </div>`;
    }
    ;
    /**
     * Генерирует представление
     */
    render() {
        const parent = (0, jquery_1.default)(this).closest('.art-uikit');
        parent.removeClass('art-uikit');
        parent.addClass('art-uikit-popup');
        return (0, lit_html_1.html) `<div class="sidebar-body">   
                        <div class="sidebar-title">${this.translationService.instant('av_filter_sort_results')}</div>  
                        <div class="text-radio">
                            ${this.sortFilter}
                        </div>
                        
                        <div class="sidebar-title">${this.translationService.instant('av_filter_search_results')}</div>

                        <fieldset class="art-fieldset">
                           ${this.wordFilter}
                        </fieldset>

                            <fieldset class="art-fieldset">
                                <legend class="text">${this.translationService.instant('av_price_range')}</legend>
                                <div class="art-range-set">
                                    <div class="art-range-set__wrap">
                                        <art-text-field class="art-field price-field" 
                                        placeholder="0"
                                        .pattern="${new RegExp(/\D+/g)}" 
                                        name="price" .control="${this.form.get('price')}" @enter="${this.apply}"></art-text-field>
                                        <art-text-field class="art-field price-field" 
                                        placeholder="10,000"
                                        .pattern="${new RegExp(/\D+/g)}" name="price_to" .control="${this.form.get('price_to')}" @enter="${this.apply}"></art-text-field>
                                    </div>
                                    <div class="art-range__wrap">${this.createRangeSlider('price', 'price_to')}</div>
                                </div>
                            </fieldset>

                            <fieldset class="art-fieldset">
                                <legend class="text">${this.translationService.instant('av_characters_count')}</legend>
                                <div class="art-range-set">
                                    <div class="art-range-set__wrap">
                                        <art-text-field class="art-field" 
                                        placeholder="0"
                                        .pattern="${new RegExp(/\D+/g)}"
                                        name="letter" .control="${this.form.get('letter')}" @enter="${this.apply}"></art-text-field>
                                        <art-text-field class="art-field" 
                                        placeholder="100"
                                        .pattern="${new RegExp(/\D+/g)}"
                                        name="letter_to" .control="${this.form.get('letter_to')}" @enter="${this.apply}"></art-text-field>
                                    </div>
                                    <div class="art-range__wrap">${this.createRangeSlider('letter', 'letter_to', 100, 1)}</div>
                                </div>
                            </fieldset>

                            <div class="field-wrap--button">
                                <button class="button btn--black" ?disabled="${this.loading}" @click="${this.apply}">${this.translationService.instant('x_apply')}</button>
                            </div>
                        </div>
                    </div>
        `;
    }
    /**
     * Меняет значение контрола с фильтром по содержимому
     */
    change(e) {
        const control = this.form.get('word_param');
        control === null || control === void 0 ? void 0 : control.resetError();
        control === null || control === void 0 ? void 0 : control.setValue(e.target.value);
    }
    /**
     * Меняет событие с фильтром сортировки
     */
    changeSort(e) {
        this.sortValue = e.target.value;
    }
    /**
     * Применяет фильтры
     */
    apply() {
        return __awaiter(this, void 0, void 0, function* () {
            this.loading = true;
            try {
                const { data } = yield this.categoryService.applyFilters(this.form.getValue());
                let redirectUrl = '';
                redirectUrl = data.redirect || '';
                let sortGetUrl = '';
                if (!this.sortValue) {
                    sortGetUrl = '';
                }
                else {
                    sortGetUrl = `${data.redirect ? '&' : '?'}sort=${this.sortValue}`;
                }
                redirectUrl += sortGetUrl;
                window.location.href = `${window.location.pathname}?${redirectUrl}`;
            }
            catch (err) {
                const hasErrors = err.errors
                    && (Array.isArray(err.errors) && err.errors.length > 0)
                    || (typeof err.errors === 'object' && Object.keys(err.errors).length > 0);
                if (!hasErrors) {
                    window.location.href = `${window.location.pathname}${this.sortValue ? '?sort=' : ''}${this.sortValue}`;
                    return;
                }
                this.form.setErrors(err.errors);
            }
            finally {
                this.loading = false;
            }
        });
    }
    /**
     * Форматирует параметры фильтрации
     */
    formatFilterValue(values = {}) {
        const keyMap = {
            letterMax: 'letter_to',
            letterMin: 'letter',
            priceMax: 'price_to',
            priceMin: 'price',
            searchString: 'word',
            searchType: 'word_param',
        };
        return Object.keys(values).reduce((carry, key) => {
            if (values[key]) {
                carry[keyMap[key]] = values[key];
            }
            return carry;
        }, {});
    }
    /**
     * Инициализирует состояние сортировки
     */
    initSort() {
        const searchGet = window.location.search.replace('?', '').split('&');
        const sortGet = searchGet.filter(item => item.indexOf('sort=') === 0);
        if (sortGet.length > 0)
            this.sortValue = sortGet[0].replace('sort=', '');
        const orderBy = this.sortValue.split('_');
        this.orderValue[orderBy[0]] = this.sortValue;
    }
    /**
     * Изменение порядка сортировки
     */
    changeAsc(el) {
        const button = el.target.closest('button');
        const nameField = button.getAttribute('data-name');
        const order = button.querySelector('svg').getAttribute('class') === 'asc' ? 'desc' : 'asc';
        this.setOrderElement(nameField, order, button.querySelector('svg'));
    }
    /**
     * Изменить направление сортировки
     */
    clickSort(el) {
        const sortName = el.target.htmlFor.replace('radio_', '');
        if (this.sortValue.indexOf(sortName) === 0) {
            const order = this.sortValue.replace(`${sortName}_`, '') === 'asc' ? 'desc' : 'asc';
            this.setOrderElement(sortName, order, el.target.parentElement.querySelector('svg'));
        }
    }
    /**
     * Установить направление сортировки
     */
    setOrderElement(nameField, order, svgElement) {
        this.orderValue[nameField] = `${nameField}_${order}`;
        this.sortValue = `${nameField}_${order}`;
        svgElement.setAttribute('class', order);
    }
};
__decorate([
    (0, decorators_js_1.state)(),
    __metadata("design:type", Boolean)
], SearchFiltersPopup.prototype, "loading", void 0);
SearchFiltersPopup = __decorate([
    (0, decorators_js_1.customElement)('art-search-filters-popup'),
    __metadata("design:paramtypes", [])
], SearchFiltersPopup);
/**
 * Возвращает шаблон авторизации пользователя
 */
function getSearchFiltersTemplate() {
    return (0, lit_html_1.html) `<art-search-filters-popup></art-search-filters-popup>`;
}
exports.getSearchFiltersTemplate = getSearchFiltersTemplate;
window.SidebarController.registerTemplate('search-filters', getSearchFiltersTemplate);
